/**
 * Check touch devices
 *
 * Indicates if the browser supports the W3C Touch Events API.
 * This *does not* necessarily reflect a touchscreen device:
 * Older touchscreen devices only emulate mouse events
 * Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
 * Future browsers may implement other event models for touch interactions
 * See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).
 * It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](https://www.html5rocks.com/en/mobile/touchandmouse/).
 * This test will also return `true` for Firefox 4 Multitouch support.
 *
 * @returns {Boolean} Result
 */
export function isTouchDevice() {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch; // eslint-disable-line
}

/**
 * Check is the input device fires touch events
 *
 * Fallback for touch devices and screen readers, intercepting ENTER and SPACE keys, but triggering 'click' instead.
 * The UIEvent.sourceCapabilities read-only property returns an instance of the InputDeviceCapabilities interface
 * which provides information about the physical device responsible for generating a touch event.
 * If no input device was responsible for the event (such as artificially triggered click event by the screen reader),
 * it returns null
 * The firesTouchEvents read-only property returns a boolean value whether the device dispatches touch events
 *
 * @param {Event} event - Event object
 * @returns {Boolean} Result
 */
export function isFiresTouchEvents(event) {
    // event.sourceCapabilities is not compatible with Safari on iOS, so the condition is inversed - see NGLORA-13683
    return !(event.sourceCapabilities && !event.sourceCapabilities.firesTouchEvents);
}
